import { ResourceType } from '../../shared/resource-type';

/**
 * The resource type for CrisLayoutTab
 *
 * Needs to be in a separate file to prevent circular
 * dependencies in webpack.
 */

export const TAB = new ResourceType('tab');
